// Which table row a record is. Referral rows can share a document (file_token) across
// recipients (send_token), and Assigned rows share both across assignments (slug), so
// a row is only the same row when all three match.

const same = (a, b) => (a || null) === (b || null);

export const isSameRow = (row, record) => Boolean(row && record
  && same(row.file_token, record.file_token)
  && same(row.send_token, record.send_token)
  && same(row.slug, record.slug));

// The record's position in rows: the same object first, then the same tokens.
export const findRowIndex = (rows, record) => {
  if (!record || !rows) return -1;
  const identical = rows.indexOf(record);
  if (identical !== -1) return identical;
  return rows.findIndex((row) => isSameRow(row, record));
};

// One entry per document, keeping the first row of each.
export const distinctDocuments = (records) => {
  const seen = new Set();
  return records.filter((record) => {
    const key = record?.file_token;
    if (!key) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
